import EADialog from '../../common/EADialog';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Context } from '../../../states/Store';
import _ from "lodash";
import EAIcon from '../../common/EAIcon';
import useStyles from "../../../style/js-style/containers/thirdparties/thirdpartyPanel/thirdpartyPanelStyle";
import ROUTES from '../../../config/Routes';
import { useHistory } from 'react-router-dom';
import TPSheet from '../../../containers/thirdparties/thirdparty-sheet/TPSheet';
import { navigationItems } from '../../../containers/thirdparties/thirdparty-sheet/ThirdpartySheetUtils';
import EAColorIcon from '../../common/EAColorIcon';
import { styled, Tooltip, useTheme } from '@mui/material';
import { TooltipProps } from '@mui/material';
import { tooltipClasses } from '@mui/material/Tooltip';
import i18n from '../../../i18n/i18n';

const ThirdpartiesPanel = ({ isOpen, handleClose, thirdparties, isLoading = true, thirdpartySelectedId, accountId, active }) => {
  const { classes } = useStyles();
  let history = useHistory();
  const [state, dispatch] = useContext(Context);
  const [selectedThirdpartyIndex, setSelectedThirdpartyIndex] = useState(null);
  const [selectedThirdparty, setSelectedThirdparty] = useState();
  const [currentGlobalIndex, setCurrentGlobalIndex] = useState(null);
  const [isPageLoading, setPageLoading] = useState(isLoading);
  const [firstRender, setFirstRender] = useState(false);
  const [currentSection, setCurrentSection] = useState(navigationItems[0].sectionId);
  const [thirdPartyNameVisible, setThirdPartyNameVisible] = useState(false);
  const [isDisplayingCopyPathStyle, setIsDisplayingCopyPathStyle] = useState(false);
  const [toolTipHover, setToolTipHover] = useState(false);
  const scrollRef = useRef(null);
  const denominationRef = useRef(null);
  const theme = useTheme();

  // Définis le nouveau tiers à afficher en fonction de l'index
  const setNewIndex = (value) => {
    const newLocalIndex = selectedThirdpartyIndex + value;
    const newGlobalIndex = currentGlobalIndex + value;

    const isAfterLastLocal = newLocalIndex + 1 > thirdparties.length;
    const isBeforeFirstLocal = newLocalIndex === -1;

    const isAfterLastGlobal = newGlobalIndex + 1 >= state.pagination.count;
    const isBeforeFirstGlobal = newGlobalIndex === -1;

    const nextPage = state.pagination.page + 1
    const previousPage = state.pagination.page - 1 >= 0 ? state.pagination.page - 1 : 0;

    // Previous page
    if (isBeforeFirstLocal){
      if (!isBeforeFirstGlobal){
        dispatch({ type: "PAGINATION", pagination: { ...state.pagination, page: previousPage } });
        setSelectedThirdpartyIndex(state.pagination.rowPerPage - 1);
      }else{
        setSelectedThirdpartyIndex(0);
      }

    // Next page
    }else if(isAfterLastLocal){
      if (!isAfterLastGlobal){
        setPageLoading(true);
        dispatch({ type: "PAGINATION", pagination: { ...state.pagination, page: nextPage } })
        setSelectedThirdpartyIndex(0);
      }else{
        setSelectedThirdpartyIndex(thirdparties.length - 1);
      }

    // Same page
    }else{
      setSelectedThirdpartyIndex(newLocalIndex);
    }
  }

  // Loader used when changing page to avoid calling thirdparty of previous/following page, before it charges in.
  useEffect(() => {
    setPageLoading(isLoading);
  }, [isLoading])

  // Gestion d'un délai apres la copy d'un path pour l'accès a une fiche tiers
  useEffect(() => {
    if (isDisplayingCopyPathStyle){
      setTimeout(
        () => {
          setIsDisplayingCopyPathStyle(false);
          setToolTipHover(false)
        }
        , 700
      )
    }
  }, [isDisplayingCopyPathStyle]);

  const goToThirdpartySheet = (thirdpartyId) => {
    const route = active
      ? ROUTES.THIRDPARTY_DETAIL
      : ROUTES.ARCHIVES.THIRDPARTY_DETAIL;
    history.push(`/${accountId}/${route.replace(":thirdpartyId", thirdpartyId)}`);
  };

  // Copie du lien vers la fiche tiers
  const copyThirdpartyLinkToClipBoard = (thirdpartyId) => {
    const route = active
      ? ROUTES.THIRDPARTY_DETAIL
      : ROUTES.ARCHIVES.THIRDPARTY_DETAIL;
    const path = `/${accountId}/${route.replace(":thirdpartyId", thirdpartyId)}`;

    const fullPath = window.location.protocol + '//' + window.location.host + path;
    navigator.clipboard.writeText(fullPath)
  }

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} arrow={'top'} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.grey.grey800,
      color: 'white',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.grey.grey800,
    },
  }));

  useEffect(() => {
    setCurrentGlobalIndex(
      ((state.pagination.page) * state.pagination.rowPerPage) + selectedThirdpartyIndex
    );
  }, [selectedThirdpartyIndex, state.pagination]);

  // Initialise la position du tiers à afficher la premiere fois que la pop up est ouverte
  useEffect(() => {
    if (!selectedThirdpartyIndex && !firstRender){
      setFirstRender(true)
      const indexOfInitialThirdparty = _.findIndex(thirdparties, { thirdpartyId: thirdpartySelectedId });
      setSelectedThirdpartyIndex(indexOfInitialThirdparty);
    }
  }, [thirdpartySelectedId, thirdparties, firstRender, selectedThirdpartyIndex]);

  // A chaque modification du tiers, met à jour les valeurs du tier selectionné
  useEffect(() => {
    if(!isPageLoading) {
      setSelectedThirdparty(thirdparties[selectedThirdpartyIndex]);
    }
  }, [thirdparties, selectedThirdpartyIndex, isPageLoading]);

  useEffect(() => {
    const handleScroll = _.debounce(() => {
      for (const section of navigationItems) {
        const element = document.getElementById(section.sectionId);
        if (element) {
          const rect = element?.getBoundingClientRect();
          if (rect?.top <= 260 && rect?.bottom >= 250 ) {
            setCurrentSection(section.sectionId);
          }
        }
      }

      // Au-dessus de la premiere section
      const firstSection = document.getElementById(navigationItems[0].sectionId)?.getBoundingClientRect();
      if (firstSection?.top > 130) {
        setCurrentSection(navigationItems[0].sectionId);
      }
      // En dessous de la dernière section
      const lastSection = document.getElementById(navigationItems[navigationItems.length - 1].sectionId)?.getBoundingClientRect();
      if (lastSection?.bottom < 200) {
        setCurrentSection(navigationItems[navigationItems.length - 1].sectionId);
      }

      // Affichage de la dénomination
      const denominationPosition = denominationRef.current.getBoundingClientRect();
      setThirdPartyNameVisible(denominationPosition.top < 60);

    },10);

    setTimeout(() => {
      const scrollElement = scrollRef.current;

      if (scrollElement) {
        scrollElement.addEventListener('scroll', handleScroll);
      }
      return () => {
        if (scrollElement) {
          scrollElement.removeEventListener('scroll', handleScroll);
        }
      };
    },100)
  }, [scrollRef]);

  return (
    selectedThirdparty &&
    state.pagination && (
      <>
        <EADialog
          isOpen={isOpen}
          onCancel={handleClose}
          isFixed
          hasActions={false}
          scrollRef={scrollRef}
          paperProps={{
            PaperProps: {
              sx: state?.drawerIsOpened
                ? {
                    position: 'fixed',
                    top: -32,
                    right: -32,
                    width: '70vw',
                    maxWidth: '1281px',
                    // minWidth: "70vw",
                    borderRadius: 0,
                    maxHeight: '100vh',
                    height: '100vh',
                  }
                : {
                    position: 'fixed',
                    top: -32,
                    right: -32,
                    width: '70vw',
                    borderRadius: 0,
                    maxHeight: '100vh',
                    height: '100vh',
                  },
            },
          }}
          customDialogStyle={{ padding: '0 !important', position: 'relative' }}
        >
          <div className={classes.dialogWrapper}>
            {/* Header */}
            <div className={classes.headerWrapper}>
              {/* Navigation */}
              <div className={classes.backAndNavigationWrapper}>
                <div
                  className={classes.backNavigation}
                  onClick={() => handleClose()}
                >
                  <EAIcon
                    icon={'/thirdpartyPanel/back'}
                    style={{ marginRight: '15px' }}
                  />
                </div>
                <div className={classes.indexNavigation}>
                  {currentGlobalIndex + 1} / {state.pagination.count}
                </div>

                <div className={classes.navigationWrapper}>
                  <div
                    className={classes.navigationLeft}
                    onClick={() => setNewIndex(-1)}
                  >
                    <EAIcon icon={'/thirdpartyPanel/arrow'} />
                  </div>
                  <div
                    className={classes.navigationRight}
                    onClick={() => setNewIndex(+1)}
                  >
                    <EAIcon
                      icon={'/thirdpartyPanel/arrow'}
                      style={{ transform: 'rotate(180deg)' }}
                    />
                  </div>
                </div>

                {selectedThirdparty.name && thirdPartyNameVisible && (
                  <div className={classes.informationsTitleWrapper}>
                    <div className={classes.informationsEtablissement}>
                      <EAColorIcon
                        icon={'thirdparty_green'}
                        svgStyle={{
                          width: '100%',
                          marginRight: '5px',
                          position: 'relative',
                          top: '2px',
                          flex: 1,
                        }}
                        width={'20px'}
                        height={'20px'}
                      />
                      <div>{selectedThirdparty.name}</div>
                    </div>
                  </div>
                )}
              </div>

              {/* Actions */}
              <div className={classes.actionsWrapper}>
                <div className={classes.verticalDivider} />

                {/* Copy */}
                <HtmlTooltip
                  onMouseEnter={() => setToolTipHover(true)}
                  onMouseLeave={() => setToolTipHover(false)}
                  open={isDisplayingCopyPathStyle || toolTipHover}
                  title={
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      {isDisplayingCopyPathStyle ? (
                        <>
                          <EAIcon
                            icon={'/thirdpartyPanel/check_circle'}
                            style={{ marginRight: '5px' }}
                          />
                          <div>{i18n.t('thirdpartySheet.linkIsCopied')}</div>
                        </>
                      ) : (
                        <>
                          <EAIcon
                            icon={'/thirdpartyPanel/link'}
                            style={{ marginRight: '5px' }}
                          />
                          <div>{i18n.t('thirdpartySheet.copyLink')}</div>
                        </>
                      )}
                    </div>
                  }
                >
                  <div>
                    <div
                      className={classes.copyPath}
                      style={{
                        border: isDisplayingCopyPathStyle
                          ? '1px solid ' + theme.palette.primary.primary700
                          : '',
                        backgroundColor: isDisplayingCopyPathStyle
                          ? theme.palette.primary.primary50
                          : '',
                      }}
                      onMouseUp={() => {
                        setIsDisplayingCopyPathStyle(true);
                        copyThirdpartyLinkToClipBoard(
                          selectedThirdparty.thirdpartyId
                        )
                      }}
                    >
                      <EAColorIcon
                        icon={'/thirdpartyPanel/share'}
                        svgStyle={{
                          position: 'relative',
                          left: '-1px',
                          top: '4px',
                        }}
                        color={
                          isDisplayingCopyPathStyle
                            ? theme.palette.primary.primary700
                            : 'gray'
                        }
                      />
                    </div>
                  </div>
                </HtmlTooltip>

                {/* Full page */}
                <div>
                  <div
                    className={classes.openFullPage}
                    onClick={() =>
                      goToThirdpartySheet(selectedThirdparty.thirdpartyId)
                    }
                  >
                    <EAIcon
                      icon={'/thirdpartyPanel/full'}
                      style={{ position: 'relative', left: '-1px' }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Main content */}
            <div className={classes.mainContent}>
              <TPSheet
                tpId={selectedThirdparty.thirdpartyId}
                currentSectionFromTPPanel={currentSection}
                setCurrentSectionFromTPPanel={setCurrentSection}
                scrollRefPanel={scrollRef}
                denominationRef={denominationRef}
              />
            </div>
          </div>
        </EADialog>
      </>
    )
  );
};

export default ThirdpartiesPanel;
